export default "__VITE_ASSET__CLKPp8c4__"